import styled from 'styled-components';

export const TravellerForm = styled.section`
  border-radius: 0.8rem;
  border: solid 1px #e5edf6;
  margin-bottom: 1rem;
`;
export const FormContent = styled.div`
  transition: all 0.35s;
  overflow: hidden;
`;
export const FormHeaderLabel = styled.label(
  props => `
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 1.5rem 2rem;
        cursor: pointer;
        &::after {
            content: '\\276F';
            width: 2em;
            height: 2em;
            text-align: center;
            transform: rotate(90deg);  
            -webkit-transition: all .35s;
            transition: all .35s;
            color: #898b91;
            font-size: 1.2rem;
            padding-top:0.5rem;
        }
        
    `,
);
export const FormHeaderInput = styled.input`
  position: absolute;
  opacity: 0;
  z-index: -1;
  &:checked + ${FormHeaderLabel}::after {
    transform: rotate(-90deg);
  }
  &:checked ~ ${FormContent} {
    max-height: 100vh;
  }
`;
export const FormLabelTxt = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width:100%
  .travellerIcon{
    width: 3.2rem; 
    height: 3.2rem; 
    margin-right: 1.6rem
  }
`;
export const TravellerInfo = styled.div`
  align-items:center;
  display:flex;
  justify-content:space-between;
  margin-bottom: 1.6rem;
`;
export const FlexOne = styled.div`
  flex: 1;
`;
export const TravellerNumber = styled.p`
  margin-bottom: 0.2rem;
  font-weight: bold;
  font-size: 1.6rem;
  color: #141823;
  line-height: 1;
`;
export const PassengerType = styled.p`
  font-size: 1.4rem;
  color: #777777;
`;
export const TravellerSeat = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-left: 1px solid #eef4fd;
  border-right: 1px solid #eef4fd;
  padding: 0 1rem;
`;
export const SeatNumber = styled.div(
  props => `
        color: #141823;
        font-size: 1.4rem;
        font-weight: bold;
        font-family:${props.theme.font.fontFamily}; 
    `,
);
export const FormWrap = styled.div`
  padding: 0 2em 1rem 7rem;
`;
export const FormInnerContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  label {
    font-size: 1.4rem;
    color: #141823;
    padding-bottom: 1rem;
  }
  input {
    border: 1px solid #e5edf6;
    border-radius: 0.4rem;
    padding: 1rem;
    width: 100%;
    font-size: 1.4rem;
    height: 3.5rem;
    background: white;
    outline: 0;
    &.error {
      border: 1px solid #ff3a5c;
    }
  }
`;
export const GenderWrap = styled.div`
  // width: 20%;
  
  label {
    font-size: 1.4rem;
    line-height: 1.8rem;
    color: #141823;
    display: block;
  }
  .genderTabs{
    background: #F7F7F7;
    border-radius: 0.4rem;
    display: flex;
  }
  .genderTabsList{
    color: #777777;
    cursor: pointer;
    padding: 0.4rem 0.7rem;
    align-items: center;
    border-radius: 4px;
    display: flex
    font-weight: bold;
  }
  .genderTabsList.selected{
    background: #fff;
    color:#2276E3
    box-shadow: 0px 1px 6px rgba(108, 92, 121, 0.15);
  }
  .genderIcon{
    width: 2.7rem; 
    height: 2.7rem;
    margin-right: 0.6rem;
  }
`;
export const FullName = styled.div`
  display: flex;
  flex-direction: column;
  // width: 60%;
  width: 28.3rem
  padding-right: 1rem;
`;
export const Age = styled.div`
  display: flex;
  flex-direction: column;
  // width: 10%;
  width: 8.7rem
`;
export const Error = styled.p`
  font-size: 1.2rem;
  color: #ff3a5c;
  padding-top: 0.5rem;
`;
export const NameListWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 2rem;
`;
export const NameList = styled.span`
  padding: 0.5rem 1rem;
  border-radius: 0.2rem;
  background: #e5edf6;
  margin-right: 1rem;
  color: #2276e3;
  font-size: 1.2rem;
  cursor:pointer;
`;
